export const specialMenu = {
    crypto: '暗号資産',
    virtualCard: 'バーチャルカード',
}
export const homeOneModule  = {
    title: '安全で安定した法人向けサービス',
    subTitle: '信頼できる高品質なサービス',
    descList: [
        {
            content: '10年にわたるサービス経験の蓄積'
        },
        {
            content: '9つのセキュリティ対策'
        },
        {
            content: '8つの利用シーン'
        },
    ]
}
export const homeTwoModule  = {
    title: 'グローバル資産を一括管理',
    subTitle: 'UBPayでは、ステーブルコインと法定通貨を1つのプラットフォームで管理できます'
}
export const homeThreeModule  = {
    title: 'UBPay：グローバルビジネスの最良パートナー',
    subTitle: 'ステーブルコインをミリ秒単位で即時変換。複数のシステムを切り替える必要がなく、市場変動リスクを軽減し、資産価値を守ります'
}
export const homeFourModule  = {
    title: '迅速・安全・効率的なグローバルバーチャルカードサービス',
    subTitleList: [
        {
            title: '高速発行、即時利用可能',
            subTitle: '即時発行＆即利用で、時間と労力を節約',
            img: require('@/assets/imgs/home/gaoxiao.png')
        },
        {
            title: '先進技術と強力なセキュリティ',
            subTitle: '安定した技術基盤により、カード管理や支払いがスムーズに',
            img: require('@/assets/imgs/home/jishu.png')
        },
        {
            title: '多通貨対応、便利な取引',
            subTitle: 'USD、EUR、GBPなど多様な通貨に対応し、為替損失を抑制',
            img: require('@/assets/imgs/home/bizhong.png')
        },
    ]
}
export const appDownload = {
    title: 'ダウンロード',
    desc: 'UBPayは、iOSおよびAndroid向けのモバイルアプリとして利用可能です',
}
export const footerUbpayDesc = {
    content: 'Pacific銀行とEAST銀行が共同でEAST Card社を設立。本社はニューヨークと香港にあり、UB CardおよびUB Payを展開。' +
        'シンガポールに支社を構え、国際的な大手銀行と提携し、Mastercard（香港）およびDiscover®（アジア太平洋地域）の発行資格を取得しています'
}
export const footerMenu = [
    {
        name: "製品とサービス",
        router: "index",
        url: "",
        childList: [
            // {
            //     name: "マルチ通貨ウォレット",
            //     url: "multiWalletAndCcy",
            // },
            // {
            //     name: "ステーブルコイン変換",
            //     url: "transformCcy",
            // },
            {
                name: "バーチャルバンクカード",
                url: "footerVirtualCard",
            },
            {
                name: "支払いと出金",
                url: "payment",
            },
            {
                name: "セキュリティ",
                url: "security",
            },
        ]
    },
    {
        name: "会社概要",
        router: "scienceResult",
        url: "",
        childList: [
            {
                name: "UBPayについて",
                url: "aboutUbpay",
            },
            {
                name: "お問い合わせ",
                url: "contactUs",
            }
        ]
    },
    {
        name: "Policies & Regulations",
        router: "productCenter",
        url: "",
        childList: [
            // {
            //     name: "利用規約",
            //     url: "termsOfUse",
            // },
            {
                name: "プライバシーポリシー",
                url: "privacyPolicy",
            },
            {
                name: "ヘルプセンター",
                url: "helpCenter",
            }
        ]
    },
    {
        name: "APP",
        router: "newsCenter",
        url: "",
        childList: [
            {
                name: "アプリダウンロード",
                url: "appDownload",
            }
        ]
    }
]
export const cryptoOneModule = {
    title: '複数の通貨とチェーンに対応',
    subTitle: '複数のブロックチェーン資産を1つのプラットフォームで自由に管理。EthereumでもTRONでも、簡単に切り替えて即時取引可能。'
}
export const cryptoTwoModule = {
    title: 'ステーブルコインから法定通貨への両替',
    subTitle: 'UBPayはステーブルコインをミリ秒レベルで即時変換し、システムの切替不要で、価格変動リスクを軽減し、資産価値を保護します。'
}
export const cryptoThreeModule = {
    title: '専門チームがあなたの暗号資産取引の安全を保証します。',
    threeList: [
        {
            content: '低手数料'
        },
        {
            content: '分散型'
        },
        {
            content: '支持多条公链'
        },
        {
            content: '即時決済'
        },
        {
            content: '稳定币兑换'
        },
        {
            content: '降低欺诈风险'
        },
        {
            content: '全球充提币'
        },
        {
            content: '24時間年中無休のカスタマーサポート'
        },
    ]
}
export const virtualCardOneModule = {
    label: 'DiscoverとMastercardの二重チャネル対応',
    title: '世界中のオンライン支出に完全対応し、多様な支払いニーズに対応します',
    subTitleList: [
        {
            img: require('@/assets/imgs/home/gaoxiao2.png'),
            title: "即時カード発行、即時入金",
            content: "待ち時間なしでDiscover/Mastercardのバーチャルカードをオンライン申請、すぐにグローバル決済を開始"
        },
        {
            img: require('@/assets/imgs/home/jishu2.png'),
            title: "先進技術と強力なセキュリティ",
            content: "安定した技術基盤により、カード管理や支払いがスムーズに"
        },
        {
            img: require('@/assets/imgs/home/bizhong2.png'),
            title: "多通貨対応、便利な取引",
            content: "USD、EUR、GBPなど多様な通貨に対応し、為替損失を抑制"
        },
        {
            img: require('@/assets/imgs/home/baozhang.png'),
            title: "匿名・プライバシー重視",
            content: "本人確認なしで取得可能・高匿名性"
        }
    ]
}
export const virtualCardTwoModule = {
    title: 'DiscoverとMastercardの2種類のカード対応',
    cardGroup: [
        {
            name: 'Discover',
            descList: [
                {
                    content: 'お得な価格、快適な利用体験'
                },
                {
                    content: '多様な場面で利用可能、繰り返し使用可'
                },
                {
                    content: '共有限度額で企業のカード管理を効率化'
                }
            ]
        },
        {
            name: 'Mastercard',
            descList: [
                {
                    content: '多场景支持，广泛的商户接受度'
                },
                {
                    content: '安全性和欺诈保护'
                },
                {
                    content: '良好的客户服务'
                }
            ]
        }
    ]
}
export const virtualCardThreeModule = {
    title: '即時発行、簡単管理',
    openMgtList: [
        {
            title: '即時発行',
            content: '无需等待，支持秒速开通Mastercard&DisCover虚拟卡，即开即用，开启全球之旅'
        },
        {
            title: '多通貨対応',
            content: '提供USD、EUR、GBP等多种卡片，满足特定币种支付需求，有效降低汇损'
        },
        {
            title: '先進的で安定した技術',
            content: '稳定可靠的技术架构，卡片管理和支付流程保驾护航'
        },
        {
            title: '管理方便',
            content: '配套APP线上多卡统一管理，方便您随时查看和管理卡片信息'
        },
        {
            title: '全球支付',
            content: '支持主流支付平台线上支付，包括支付宝、微信支付、轻松应对跨境电商、海淘购物，线下支付贴心服务'
        },
        {
            title: '手厚いサポートと万全の保障',
            content: '平日サポートで即時対応'
        }
    ]
}
export const virtualCardFourModule = {
    title: 'プライバシーを全面保護',
    privacyAndSecurityList: [
        {
            img: require('@/assets/imgs/home/rq.png'),
            title: "匿名・プライバシー重視",
            content: "本人確認なしで取得可能・高匿名性"
        },
        {
            img: require("@/assets/imgs/home/aq.png"),
            title: "安全・リスク管理対応",
            content: "毎回一意の番号で実カードと分離、情報漏洩を防止"
        },
        {
            img: require("@/assets/imgs/home/ed.png"),
            title: "柔軟・計画的な利用が可能",
            content: "上限設定＆審査不要、誰でも使える柔軟なバーチャルカード"
        },
    ]
}
export const popup = {
    productAndService: [
        {
            title: "收单",
            description: "支持快速接入，提供安全、高效的收款解决方案，兼容多种币种",
        },
        {
            title: "支付",
            description: "支持主流支付平台线上支付，包括支付宝、微信支付、轻松应对跨境电商、海淘购物，线下支付贴心服务",
        },
        {
            title: "多币种",
            description: "管理多种数字货币与法币，实现资金自由兑换与流转，覆盖主流币种",
        },
        {
            title: "稳定币转换",
            description: "币种实时、秒级转换，快速应对不稳定的市场",
        },
        {
            title: "安全",
            description: "银行级别风控，确保用户资金和账户安全",
        },
        {
            title: "费用",
            description: "透明低费率结构，无隐藏成本",
        }
    ],
    aboutUs: [
        {
            title: "关于ubpay",
            description: "在传统金融与区块链生态之间驾起合规、高速、安全的桥梁，让全球支付更加去中心化、数字化与智能化。",
        },
        {
            title: "联系我们",
            description: "专属客服与技术支持团队，7×24小时响应，助您高效解决业务问题。",
        },
    ],
    prContent: {
        regulationsOne: {
            subTitle: '1，简介',
            content: '本平台重视您的隐私，并致力于保护您的个人信息安全。本文《隐私条款》将说明我们在您访问我们的网站、使用我们的服务或与我们互动时，如何收集、使用、披露和保护您的信息。'
        },
        regulationsTwo: {
            subTitle: '2，我们收集的信息',
            content: '我们可能收集以下类型的信息：',
            list: [
                {
                    content: '个人身份信息（如姓名、身份证号、地址、电话号码、电子邮件）'
                },
                {
                    content: '财务信息（如银行账户、钱包地址、交易记录）'
                },
                {
                    content: '技术数据（如IP地址、浏览器类型、操作系统）'
                },
                {
                    content: '使用数据（如登录记录、点击行为、偏好设置）'
                },
                {
                    content: 'KYC信息（了解您的客户相关文件）'
                }
            ]
        },
        regulationsThree: {
            subTitle: '3，我们如何使用您的信息',
            content: '我们使用您的信息以：',
            list: [
                {
                    content: '提供、维护和改进我们的服务'
                },
                {
                    content: '验证您的身份并履行法律义务'
                },
                {
                    content: '处理交易和管理账户'
                },
                {
                    content: '防止欺诈、洗钱和非法活动'
                },
                {
                    content: '与您沟通有关服务更新和促销活动'
                }
            ]
        },
        regulationsFour: {
            subTitle: '4，信息共享与披露',
            content: '我们不会出售您的个人信息。但在以下情况下，我们可能会共享您的信息：',
            list: [
                {
                    content: '与关联公司及服务提供商签署保密协议的前提下共享'
                },
                {
                    content: '根据法律要求与监管机构和执法机关共享'
                },
                {
                    content: '经您同意后与业务合作伙伴共享用于运营或促销目的'
                }
            ]
        },
        regulationsFive: {
            subTitle: '5，数据保留',
            content: '我们仅在达成本政策所述目的或遵守法律义务所需的期限内保留您的个人信息。'
        },
        regulationsSex: {
            subTitle: '6，数据安全',
            content: '我们采取适当的技术和组织措施，以防止您的个人数据被未经授权访问、披露、修改或销毁。'
        },
        regulationsSeven: {
            subTitle: '7，您的权利',
            content: '您有权：',
            list: [
                {
                    content: '访问和更正您的个人信息'
                },
                {
                    content: '要求删除或限制对您信息的处理'
                },
                {
                    content: '随时撤回您的同意'
                },
                {
                    content: '向数据保护机构投诉'
                }
            ]
        },
        regulationsEight: {
            subTitle: '8，Cookies与追踪技术',
            content: '我们使用Cookies和类似技术来提升您的使用体验，分析网站使用情况，并提供个性化内容。'
        },
        regulationsNine: {
            subTitle: '9，国际数据传输',
            content: '您的信息可能在您所在国家以外的司法管辖区进行处理和存储。我们将确保采取适当的保护措施。'
        },
        regulationsTen: {
            subTitle: '10，政策变更',
            content: '我们保留随时更新本隐私条款的权利。如有重大变更，我们将通过网站或其他方式通知您。'
        }
    },
    helpCenterList: [
        {
            title: '1，如何注册成为ubpay的用户？',
            content: '下载ubapy的APP，打开APP之后点击“注册”按钮，您可以用电子邮箱注册账号。当收到系统发送的验证码邮件之后，输入邮件验证码、密码，勾选用户注册协议，提交之后即可创建ubpay账号。'
        },
        {
            title: '2，是否必须完成实名认证(KYC)才能使用ubpay？',
            content: '数字资产充值，部分地区可在未实名的情况下使用；如果需要申请银行卡服务，你必须完成KYC认证。KYC包括提交身份证明文件(例如：身份证、护照、驾照)，审核时间通常为1~12小时之内。'
        },
        {
            title: '3，有账号更改邮箱服务吗？',
            content: '有的，在个人中心有更改登录邮箱的功能，输入新邮箱，提交系统发送的邮件验证码之后，可以更改登录邮箱。'
        },
        {
            title: '4，忘记密码怎么办？',
            content: '在登录页面点击“忘记密码”，输入登录邮箱之后，会收到系统发送的邮件验证码，输入验证码之后可以重置密码。但是频繁重置可能被系统检测到从而进行风控。'
        },
        {
            title: '5，一个人可以注册多个ubpay的账号吗？',
            content: '出于风控考虑，我们不建议用户注册多个ubpay的账号。'
        },
        {
            title: '6，可以申请哪些银行卡？',
            content: '我们提供两大发卡机构Mastercard和Discover® Global Network的银行卡。卡片分为实体卡和虚拟卡，虚拟卡即开即用，方便ubpay用户选择。'
        },
        {
            title: '7，什么是虚拟银行卡？',
            content: '虚拟银行卡是ubpay为用户提供的两大发卡机构的银行卡，虚拟银行卡是一种没有实体卡片的银行卡，以数字卡片的形式存在，包含卡号、有效期、CVV等信息。用户可以使用虚拟卡在网上进行支付，虚拟卡与实体卡具备相似功能，但使用更便捷、匿名性更高、安全性更强。'
        },
        {
            title: '8，虚拟银行卡支持哪些用途？',
            content: 'ubpay虚拟银行卡可应用于：绑定第三方支付平台支付宝、微信支付、ApplePay、GooglePay、PayPal等钱包进行线上支付。也可以用于在线下部分ATM机上进行取现。'
        },
        {
            title: '9，虚拟银行卡支持哪些币种？',
            content: '虚拟银行卡币种包括：美元（USD）、欧元（EUR）、英镑（GBP）等。我们还提供多币种虚拟卡，支持根据消费地自动换汇扣款，避免货币转换手续费。'
        },
        {
            title: '10，一张虚拟银行卡可以使用多久？',
            content: 'ubpay虚拟银行卡有效期通常为1~2年不等，当到了一年期之后可以续卡一年。有效期通常在卡片详情中明确显示。'
        }
    ],
    tfVersionDownload: [
        {
            content: '1，下载 TestFlight：打开 iOS 设备上的 App Store，搜索 “TestFlight”，找到 TestFlight 应用并点击 “获取” 进行下载和安装。'
        },
        {
            content: '2，获取邀请：开发者会在 App Store Connect 中创建公共测试链接或向特定用户发送邀请邮件。用户会收到包含邀请链接的邮件，或者从其他渠道获得开发者提供的邀请链接。'
        },
        {
            content: '3，使用邀请链接：点击邀请链接，系统会自动打开 TestFlight 应用。如果未自动打开，可手动打开 TestFlight。'
        },
        {
            content: '4，安装应用：在 TestFlight 应用中，点击 “开始测试” 按钮，然后点击 “安装” 按钮，等待应用下载和安装完成。安装完成后，即可在主屏幕上找到并打开应用进行使用。'
        }
    ]
}
export const aboutUBPay = {
    title: 'UBPayについて',
    content: {
        // subTitle: 'UBPayは次世代の暗号通貨決済システムを構築し、世界中の企業・個人に安全・高速・コンプライアンス対応の決済を提供します。',
        // content: '企業が暗号資産を導入できるよう、EthereumやTRONなどに対応した決済・両替・清算・出金の一括サービスを提供しています。'
        subTitle: 'UBPay 是一家专注于构建支付系统的金融科技公司，致力于为全球商户和个人提供安全、高效、合规的收付款解决方案。',
        content: '我们赋能企业接入资产世界，实现跨境支付自由、结算透明化、以及高频交易的稳定支持。我们的平台支持收款、换汇、结算、自动清算等一站式服务，旨在打造面向未来的合规支付基础设施。'
    }
}
